import { debounce } from "../../../utilities/debounce";
import { ChangeListener } from "./ChangeListener";
import { DeregisterFn } from "./DeregisterFn";
import { getDisplayModeForWidth } from "./getDisplayModeForWidth";

let ResizeListeners: ReadonlyArray<ChangeListener> = [];

const resizeHandler = debounce((): void => {
  const displayMode = getDisplayModeForWidth(window.innerWidth);

  for (const listener of ResizeListeners) {
    listener(displayMode);
  }
});

/**
 * Registers a listener for window resizing.
 * @param listener The listener to register.
 * @returns A function which when called deregisters the listener.
 */
export function registerListener(listener: ChangeListener): DeregisterFn {
  if (!ResizeListeners.includes(listener)) {
    ResizeListeners = [...ResizeListeners, listener];
  }

  if (ResizeListeners.length === 1) {
    window.addEventListener("resize", resizeHandler);
  }

  return () => {
    ResizeListeners = ResizeListeners.filter((currentListener) => currentListener !== listener);

    if (ResizeListeners.length === 0) {
      window.removeEventListener("resize", resizeHandler);
    }
  };
}
